<template>
    <button aria-label="Close this dialog" class="el-dialog__headerbtn" type="button">
        <span class="el-dialog__close">
            {{ $trans('messages.close').toLowerCase() }}
        </span>
        <i class="el-icon el-dialog__close">
            <CloseIcon/>
        </i>
    </button>
</template>

<script>
import { Close as CloseIcon } from '@element-plus/icons-vue'

export default {
    components: {
        CloseIcon,
    },
}
</script>

<style scoped>
.el-dialog__headerbtn {
    display: flex;
    align-items: center;
    right: 16px;
    width: unset;
}

span.el-dialog__close {
    font-size: 13px;
    line-height: 16px;
}

.el-dialog__headerbtn:deep(.el-icon),
.el-dialog__headerbtn:deep(.el-icon svg) {
    height: 2em;
    width: 2em;
}
</style>